import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Two-line table cell (design handoff, "Data table pattern"): a primary
 * line (14/500, ink) and an optional secondary line (12, slate). Standalone,
 * no styles of its own -- see `.cell-two-line`/`.cell-primary`/
 * `.cell-secondary` in `@seahorse/theme`'s `_table.scss`. `plain` sets the
 * primary line at normal weight (a value, not the row's name).
 */
@Component({
  selector: 'sh-cell-two-line',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
    <div class="cell-two-line">
      <div class="cell-primary" [class.cell-primary-plain]="plain()">
        {{ primary() }}
      </div>
      <div class="cell-secondary" *ngIf="secondary()">{{ secondary() }}</div>
    </div>
  `,
})
export class CellTwoLineComponent {
  primary = input.required<string>();
  secondary = input<string>();
  plain = input(false);
}
